export default "__VITE_ASSET__CAu9Q4Uj__"